module.exports = __webpack_public_path__ + "img/bg-landing.3dff21dd.jpg";